import axios from 'axios';
import config from 'config';

/**
 * Used without axios instance by avoidance of interception
 *
 * @param refreshToken
 * @returns {AxiosPromise}
 */
export default function refreshTokenRequest(refreshToken) {
  const data = new FormData();
  data.append('grant_type', 'refresh_token');
  data.append('client_id', config.clientId);
  data.append('client_secret', config.clientSecret);
  data.append('refresh_token', refreshToken);

  return axios({
    method: 'POST',
    url: `${config.authBasePath}/oauth/token`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
